import OwTitle from "../OwTitle/OwTitle";

type Props = {
    className?: string;
};

export const LoadingResults = (props: Props) => {
    return <OwTitle title={"loading"} tag={"h5"} rightIconName={"fas fa-sync fa-spin"} className={props.className} />;
};
